import type { DataTableHeader } from '@/types/vuetify';
import i18n from '@/plugins/i18n';

export function createMappingProblemPageHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: '',
            key: 'data-table-expand',
            value: 'data-table-expand',
            align: 'center',
            sortable: false,
            minWidth: 28,
            width: 28,
            cellProps: { class: 'px-0' },
        },
        {
            title: t('mappingProblem.date'),
            value: 'createdAt',
            key: 'createdAt',
            align: 'start',
            sortable: false,
            minWidth: 140,
            width: 140,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('mappingProblem.bookmaker'),
            value: 'bookmakers',
            key: 'bookmakers',
            align: 'start',
            sortable: false,
            minWidth: 120,
            width: 120,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('mappingProblem.status'),
            value: 'status',
            key: 'status',
            align: 'start',
            sortable: false,
            minWidth: 160,
            width: 160,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('mappingProblem.eventDate'),
            value: 'eventStartedAt',
            key: 'eventStartedAt',
            align: 'start',
            sortable: false,
            minWidth: 140,
            width: 140,
            headerProps: { class: 'nowrap' },
        },
        {
            title: t('mappingProblem.description'),
            value: 'description',
            key: 'description',
            align: 'start',
            sortable: false,
            minWidth: 400,
            headerProps: { class: 'nowrap' },
        },
        {
            title: '',
            value: 'infoMenu',
            key: 'infoMenu',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 24,
            cellProps: { class: 'pl-0 pr-1' },
        },
    ];
}

export function createMappingProblemSolutionHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: t('mappingProblem.solutionDescription'),
            value: 'description',
            key: 'description',
            align: 'start',
            sortable: false,
            minWidth: 400,
            headerProps: { class: 'nowrap' },
        },
        {
            title: '',
            value: 'solutionStatus',
            key: 'solutionStatus',
            align: 'start',
            sortable: false,
            minWidth: 120,
            width: 120,
            headerProps: { class: 'nowrap' },
        },
        {
            title: '',
            value: 'acceptAction',
            key: 'acceptAction',
            align: 'center',
            sortable: false,
            minWidth: 160,
            width: 160,
            cellProps: { class: 'px-0' },
        },
    ];
}
